import { Button } from "../../Button/Button/Button";
import { Icon } from "../../Icon/Icon/Icon";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import styles from "./MeteredContentBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MeteredContentBlock = function MeteredContentBlock(_ref) {
  var asideText = _ref.asideText,
    cta = _ref.cta,
    footnote = _ref.footnote,
    headline = _ref.headline,
    login = _ref.login,
    primaryText = _ref.primaryText;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.aside,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.asideInner,
        "data-e2e-name": "metered_content_aside_inner",
        children: [/*#__PURE__*/_jsx(Icon, {
          className: styles.icon,
          type: "lock",
          width: "42px",
          noFill: true
        }), /*#__PURE__*/_jsx(Text, {
          typog: "headline5",
          className: styles.asideText,
          "data-e2e-name": "metered_content_aside_text",
          children: asideText
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.contentInner,
        children: [/*#__PURE__*/_jsx(HeadingText, {
          className: styles.headline,
          align: "left",
          ariaLevel: 2,
          typog: "headline3",
          "data-e2e-name": "metered_content_headline",
          children: headline
        }), /*#__PURE__*/_jsx(Text, {
          className: styles.primaryText,
          typog: "bodycopyLarge",
          "data-e2e-name": "metered_content_primary_text",
          children: primaryText
        }), /*#__PURE__*/_jsx(Button, {
          url: cta === null || cta === void 0 ? void 0 : cta.url,
          className: styles.cta,
          type: "primary",
          "data-e2e-name": "metered_content_cta",
          children: cta === null || cta === void 0 ? void 0 : cta.text
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.login,
          "data-e2e-name": "metered_content_login",
          children: [/*#__PURE__*/_jsx(Text, {
            className: styles.footnote,
            typog: "caption",
            textElement: "span",
            childrenInline: true,
            "data-e2e-name": "metered_content_footnote",
            children: footnote
          }), /*#__PURE__*/_jsx(Button, {
            url: login === null || login === void 0 ? void 0 : login.url,
            type: "link",
            children: login === null || login === void 0 ? void 0 : login.text
          })]
        })]
      })
    })]
  });
};